<template>
  <app-card design="new" padding="compact" role="alert">
    <div class="app-error-state">
      <i class="pi pi-exclamation-circle" aria-hidden="true" />
      <p class="app-error-state__message">{{ message }}</p>
      <AppIconButton v-if="iconOnly" :label="retryLabel" tooltip-placement="left" @click="$emit('retry')">
        <i class="pi pi-refresh" aria-hidden="true" />
      </AppIconButton>
      <app-button v-else design="new" theme="dark" @click.native="$emit('retry')">
        <i class="pi pi-refresh" aria-hidden="true" />
        {{ retryLabel }}
      </app-button>
    </div>
  </app-card>
</template>

<script>
import AppButton from './AppButton.vue'
import AppCard from './AppCard.vue'
import AppIconButton from './AppIconButton.vue'

export default {
  name: 'AppErrorState',
  components: { AppButton, AppCard, AppIconButton },
  props: {
    message: { type: String, required: true },
    retryLabel: { type: String, default: 'Retry' },
    iconOnly: Boolean
  }
}
</script>

<style lang="scss" scoped>
.app-error-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $ui-space-12;
  color: $ui-text;
  font-family: $ui-font-body;
  font-size: $ui-font-size-body;

  > .pi { color: $ui-red; }
  .pi { font-size: 16px; line-height: 1; }
  &__message { flex: 1; min-width: 160px; margin: 0; line-height: 1.45; }
}
</style>
